import { useState } from "react";
import axios from "axios";
import { Camera, X } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export const PlayerPhotoModal = ({ player, collection, onClose, onSaved }) => {
  const [photoUrl, setPhotoUrl] = useState(player.Photo || "");
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const finish = (url) => { setPhotoUrl(url); onSaved(url); setTimeout(onClose, 700); };

  const uploadFile = async (file) => {
    if (!file) return;
    setUploading(true); setError("");
    try {
      const fd = new FormData();
      fd.append("file", file);
      const params = new URLSearchParams({ collection_name: collection, player_name: player.Nombre });
      const res = await axios.post(`${API}/upload/player-photo?${params}`, fd, { withCredentials: true, headers: { "Content-Type": "multipart/form-data" } });
      finish(res.data.url);
    } catch (e) {
      setError(e.response?.data?.detail || "Error al subir la foto. Verifica que eres administrador.");
    }
    setUploading(false);
  };

  const saveUrl = async () => {
    if (!photoUrl) return;
    setUploading(true); setError("");
    try {
      await axios.put(`${API}/ranking/collection/${encodeURIComponent(collection)}/photo`, { photo_url: photoUrl, player_name: player.Nombre, player_position: player.Posicion }, { withCredentials: true });
      finish(photoUrl);
    } catch (e) {
      setError(e.response?.data?.detail || "Error al guardar la foto.");
    }
    setUploading(false);
  };

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4" data-testid="player-photo-modal">
      <div className="glass-card rounded-2xl p-6 max-w-md w-full border border-purple-500/40">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold text-yellow-400">Foto · {player.Nombre}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white" data-testid="photo-modal-close"><X /></button>
        </div>
        <div className="flex justify-center mb-4">
          <div className="w-28 h-28 rounded-full overflow-hidden border-2 border-purple-500 bg-purple-900/50 flex items-center justify-center">
            {photoUrl ? <img src={photoUrl} alt="Preview" className="w-full h-full object-cover" data-testid="photo-preview" /> : <Camera size={32} className="text-gray-500" />}
          </div>
        </div>
        <label className="block cursor-pointer mb-4">
          <input type="file" accept="image/*" className="hidden" onChange={(e) => uploadFile(e.target.files?.[0])} data-testid="photo-file-input" />
          <div className="flex items-center justify-center gap-2 px-4 py-4 rounded-xl border-2 border-dashed border-purple-600 hover:border-yellow-400 text-gray-300 hover:text-yellow-400 transition-colors text-sm font-semibold">
            {uploading ? <><div className="w-4 h-4 border-2 border-yellow-400 border-t-transparent rounded-full animate-spin" /> Guardando...</> : <><Camera size={18} /> Subir foto desde tu dispositivo</>}
          </div>
        </label>
        <p className="text-gray-400 text-xs mb-1">O pega una URL:</p>
        <input type="text" placeholder="https://..." value={photoUrl} onChange={(e) => setPhotoUrl(e.target.value)} className="w-full px-4 py-2 bg-gray-800 border border-purple-700 rounded-lg text-white text-sm focus:outline-none focus:border-pink-500" data-testid="photo-url-input" />
        {error && <p className="text-red-400 text-xs mt-2" data-testid="photo-error">{error}</p>}
        <p className="text-[11px] text-gray-500 mt-2">La foto se aplicará al jugador en todos los rankings donde aparezca con el mismo nombre.</p>
        <div className="flex gap-3 mt-4">
          <button onClick={onClose} className="flex-1 py-2 border border-gray-600 rounded-lg text-gray-400 hover:bg-gray-800 text-sm">Cancelar</button>
          <button onClick={saveUrl} disabled={!photoUrl || uploading} className="flex-1 py-2 bg-gradient-to-r from-green-500 to-emerald-500 rounded-lg font-semibold text-white text-sm disabled:opacity-50" data-testid="save-photo-btn">Guardar URL</button>
        </div>
      </div>
    </div>
  );
};
